/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const BfMapMarkerType = {
    warningFireAdvice: 'warningFireAdvice',
    warningFireEvacuateNow: 'warningFireEvacuateNow',
    warningFireWatchAndAct: 'warningFireWatchAndAct',
    warningFireEmergencyWarning: 'warningFireEmergencyWarning',
    warningUnknown: 'warningUnknown',
    warningNotApplicable: 'warningNotApplicable',
    warningInformation: 'warningInformation',
    incidentFireUncontrolled: 'incidentFireUncontrolled',
    incidentFireControlled: 'incidentFireControlled',
    incidentFireBurn: 'incidentFireBurn',
    incidentWindDamaging: 'incidentWindDamaging',
    burnArea: 'burnArea',
    roadClosed: 'roadClosed',
    roadHazard: 'roadHazard',
    aircraftDefaultActive: 'aircraftDefaultActive',
    aircraftDefaultLightActive: 'aircraftDefaultLightActive',
    aircraftDefaultMediumActive: 'aircraftDefaultMediumActive',
    aircraftDefaultHeavyActive: 'aircraftDefaultHeavyActive',
    aircraftHelicopterActive: 'aircraftHelicopterActive',
    aircraftJet4HeavyActive: 'aircraftJet4HeavyActive',
    aircraftJet2HeavyActive: 'aircraftJet2HeavyActive',
    aircraftJet2MediumActive: 'aircraftJet2MediumActive',
    aircraftJet4MediumActive: 'aircraftJet4MediumActive',
    aircraftJet2LightActive: 'aircraftJet2LightActive',
    aircraftTurbo4Active: 'aircraftTurbo4Active',
    aircraftTurbo4MediumActive: 'aircraftTurbo4MediumActive',
    aircraftTurbo2MediumActive: 'aircraftTurbo2MediumActive',
    aircraftTurbo1MediumActive: 'aircraftTurbo1MediumActive',
    aircraftTurbo2LightActive: 'aircraftTurbo2LightActive',
    aircraftTurbo1LightActive: 'aircraftTurbo1LightActive',
    aircraftProp2LightActive: 'aircraftProp2LightActive',
    aircraftProp1LightActive: 'aircraftProp1LightActive',
    aircraftDefault: 'aircraftDefault',
    aircraftDefaultLight: 'aircraftDefaultLight',
    aircraftDefaultMedium: 'aircraftDefaultMedium',
    aircraftDefaultHeavy: 'aircraftDefaultHeavy',
    aircraftHelicopter: 'aircraftHelicopter',
    aircraftJet4Heavy: 'aircraftJet4Heavy',
    aircraftJet2Heavy: 'aircraftJet2Heavy',
    aircraftJet4Medium: 'aircraftJet4Medium',
    aircraftJet2Medium: 'aircraftJet2Medium',
    aircraftJet2Light: 'aircraftJet2Light',
    aircraftTurbo4: 'aircraftTurbo4',
    aircraftTurbo4Medium: 'aircraftTurbo4Medium',
    aircraftTurbo2Medium: 'aircraftTurbo2Medium',
    aircraftTurbo1Medium: 'aircraftTurbo1Medium',
    aircraftTurbo2Light: 'aircraftTurbo2Light',
    aircraftTurbo1Light: 'aircraftTurbo1Light',
    aircraftProp2Light: 'aircraftProp2Light',
    aircraftProp1Light: 'aircraftProp1Light',
    warningGenericWhite: 'warningGenericWhite',
    warningGenericAdvice: 'warningGenericAdvice',
    warningGenericWatchAndAct: 'warningGenericWatchAndAct',
    warningGenericEmergencyWarning: 'warningGenericEmergencyWarning',
    warningCycloneWhite: 'warningCycloneWhite',
    warningCycloneAdvice: 'warningCycloneAdvice',
    warningCycloneWatchAndAct: 'warningCycloneWatchAndAct',
    warningCycloneEmergencyWarning: 'warningCycloneEmergencyWarning',
    warningFloodWhite: 'warningFloodWhite',
    warningFloodAdvice: 'warningFloodAdvice',
    warningFloodWatchAndAct: 'warningFloodWatchAndAct',
    warningFloodEmergencyWarning: 'warningFloodEmergencyWarning',
    warningHeatWhite: 'warningHeatWhite',
    warningHeatAdvice: 'warningHeatAdvice',
    warningHeatWatchAndAct: 'warningHeatWatchAndAct',
    warningHeatEmergencyWarning: 'warningHeatEmergencyWarning',
    warningStormWhite: 'warningStormWhite',
    warningStormAdvice: 'warningStormAdvice',
    warningStormWatchAndAct: 'warningStormWatchAndAct',
    warningStormEmergencyWarning: 'warningStormEmergencyWarning',
    warningEvacuationWhite: 'warningEvacuationWhite',
    warningEvacuationAdvice: 'warningEvacuationAdvice',
    warningEvacuationWatchAndAct: 'warningEvacuationWatchAndAct',
    warningEvacuationEmergencyWarning: 'warningEvacuationEmergencyWarning',
    warningEvacuationEvacuateNow: 'warningEvacuationEvacuateNow',
    incidentCycloneTornado: 'incidentCycloneTornado',
    incidentEarthquake: 'incidentEarthquake',
    incidentSmoke: 'incidentSmoke',
    incidentTsunami: 'incidentTsunami',
    incidentWeather: 'incidentWeather',
    incidentHazmat: 'incidentHazmat',
    incidentHealth: 'incidentHealth',
    incidentOther: 'incidentOther',
    advisoryStorm: 'advisoryStorm',
    advisoryDamagingWinds: 'advisoryDamagingWinds',
    advisoryFlood: 'advisoryFlood',
    advisoryCycloneTornado: 'advisoryCycloneTornado',
    advisoryHail: 'advisoryHail',
    advisoryEarthquake: 'advisoryEarthquake',
    advisoryFireWeather: 'advisoryFireWeather',
    advisoryOther: 'advisoryOther',
    incidentAirQuality: 'incidentAirQuality',
    incidentDangerousAnimal: 'incidentDangerousAnimal',
    incidentPowerlines: 'incidentPowerlines',
    incidentAssistOtherAgency: 'incidentAssistOtherAgency',
    incidentShark: 'incidentShark',
    incidentTreeDown: 'incidentTreeDown',
    incidentFlood: 'incidentFlood',
    incidentSearchRescue: 'incidentSearchRescue',
    incidentStorm: 'incidentStorm',
    cyclonePosition: 'cyclonePosition',
    markerGenericPink: 'markerGenericPink',
    markerGenericOrange: 'markerGenericOrange',
    markerGenericBlue: 'markerGenericBlue',
    predictFire: 'predictFire',
    incidentVehicleAccident: 'incidentVehicleAccident',
    mediaVideoCamera: 'mediaVideoCamera',
    mediaCamera: 'mediaCamera'
} as const;

export type BfMapMarkerType = typeof BfMapMarkerType[keyof typeof BfMapMarkerType];



